.wrapper {
  .widget-title {
    height: calc(var(--spacer) * 3);
    width: fit-content;

    .error-tooltip {
      display: none;
      align-items: center;
    }

    .title-icon {
      transform: scale(0);
      transition: all 0.1s ease-in-out;
      margin-left: var(--spacer);
      display: none;
    }
  }

  &.widget-1-3-ratio,
  &.widget-2-3-ratio,
  &.widget-full-width {
    .widget-title.has-action {
      .title-icon {
        display: inline;
      }
    }
  }

  &.is-loading {
    .error-tooltip {
      display: none !important;
    }
  }

  &.is-empty,
  &.is-error {
    .apexcharts-series {
      .apexcharts-bar-area {
        fill: var(--grey-layout-203-dark-theme-disabled-text) !important;
      }
    }

    .bb-chart-bar {
      .bb-shape {
        fill: var(--grey-layout-203-dark-theme-disabled-text) !important;
      }
    }

    .gz-data-item--bullet{
      background-color: var(--grey-layout-202-disabled-icons) !important;
    }

    .apexcharts-legend-series {
      span.apexcharts-legend-marker {
        &:before {
          content: '';
          width: 10px;
          height: 10px;
          position: absolute;
          background: var(--grey-layout-202-disabled-icons);
          display: block;
        }
      }
    }
  }

  &:not(.is-error):not(.is-empty):not(.is-loading) {
    .widget-title {
      &.has-action {
        cursor: pointer;
        display: inline-flex;
        width: fit-content;

        &:hover,
        &:focus,
        &:active {
          .title-icon {
            transform: scale(1);
          }
        }

        &:hover {
          color: var(--blue-layout-300-active);
        }

        &:focus {
          color: var(--blue-layout-500-focus);
        }

        &:active {
          color: var(--blue-layout-300-active);
        }
      }
    }

    .gz-data-item {
      &--details {
        &.has-action {
          cursor: pointer;

          &:hover {
            .gz-data-item {
              &--title,
              &--value {
                color: var(--blue-layout-300-active);
                transition: color 0.3s ease-in-out;
              }
            }
          }

          &:focus {
            .gz-data-item {
              &--title,
              &--value {
                color: var(--blue-layout-500-focus);
                transition: color 0.3s ease-in-out;
              }
            }
          }

          &:active {
            .gz-data-item {
              &--title,
              &--value {
                color: var(--blue-layout-300-active);
                transition: color 0.3s ease-in-out;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1600px) {
    &.widget-1-3-ratio,
    &.widget-2-3-ratio {
      .widget-title {
        padding-right: calc(4 * var(--spacer));

        .error-tooltip {
          height: calc(var(--spacer) * 3);
          right: 0;
        }
      }
    }
  }
}

gz-loader {
  --loader-padding-bottom: var(--spacer);
}

.widget-loading {
  position: absolute;
  width: 100%;
  height: 150px;
  display: none;
}

.widget-empty {
  display: none;
}

.widget-missing-license {
  display: none;
}

.is-empty {
  .widget-empty {
    display: block !important;
  }

  .widget-active {
    display: none !important;
  }

  .widget-missing-license {
    display: none !important;
  }

  .gz-data-item {
    &--delta {
      width: 0;
      margin-left: 0;
    }
  }
}

.is-loading {
  .widget-loading {
    display: block !important;
  }

  .widget-active {
    display: none !important;
  }
}

.is-missing-license {
  .widget-empty {
    display: none !important;
  }

  .widget-loading {
    display: none !important;
  }

  .widget-active {
    display: none !important;
  }
}

.donut-chart-error {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 7px solid var(--grey-layout-203-dark-theme-disabled-text, var(--grey-layout-203-dark-theme-disabled-text));
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 1600px) {
  .donut-chart-error {
    width: 110px;
    height: 110px;
  }
}

.disabled-field-error {
  pointer-events: none;
}

.dashboard-error,
.dashboard-empty {
  display: none;

  &--image {
    display: block;
    margin: 0 auto;
    max-width: 268px;
    height: auto;
    margin-bottom: calc(5 * var(--spacer));
  }

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}

.is-error {
  .widget-title {
    .error-tooltip {
      display: flex;
    }
  }

  .gz-data-item {
    &--delta {
      width: 0;
      margin-left: 0;
    }
  }
}

.widget-title {
  position: relative;
  display: flex;
  align-items: center;
  color: var(--main-titles-inputs-600);

  .error-tooltip {
    margin-left: var(--spacer);

    .icon {
      font-size: 18px;
    }
  }
}

.gz-data-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  line-height: 1;

  &:last-of-type {
    margin-bottom: 0;
  }

  &--title {
    font-family: var(--font-family-secondary);
    color: var(--main-titles-inputs-600);
    font-size: var(--body-size-medium);
  }

  &--details {
    display: flex;
    flex: 1;
    justify-content: space-between;
  }

  &--bullet {
    min-width: 10px;
    height: 10px;
    margin-right: var(--spacer);
    display: inline-block;
    margin-top: 1px;
  }

  &--value {
    align-self: flex-end;
    margin-left: auto;
    margin-bottom: auto;
    font-weight: bold;
    min-width: 24px;
    text-align: end;
  }

  &--delta {
    align-self: flex-end;
    margin-bottom: auto;
    margin-left: calc(var(--spacer) * 3);
    width: 16px;
    display: flex;
    place-content: end;
    flex-wrap: wrap;
    font-weight: bold;
  }

  &--value, &--delta {
    font-family: var(--font-family-secondary-mono);
  }
}

.gz-data-list-item {
  padding-top: var(--spacer);
  padding-bottom: var(--spacer);
  border-bottom: 1px solid var(--chart-101-pressed-dividers);

  .gz-data-item {
    &--title {
      width: 80%;
    }
  }

  &:last-of-type {
    border-bottom: none;
  }
}

gz-info-box.widget-info-box {
  --info-box-icon-padding: calc(var(--spacer) * 2) var(--spacer) calc(var(--spacer) * 1.5) 0;
  padding: 0;
  cursor: default;

  &::part(container) {
    border: none;
  }

  gz-tooltip {
    width: 100%;
  }

  .two-line-tooltip, .three-line-tooltip, .four-line-tooltip {
    display: -webkit-box;
    line-height: 1.5;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .two-line-tooltip {
    -webkit-line-clamp: 2;
  }

  .three-line-tooltip {
    -webkit-line-clamp: 3;
  }

  .four-line-tooltip {
    -webkit-line-clamp: 4;
  }
}

.separator {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}
